import React from 'react';
import './modable.scss';

export default function (modals, modalProps = {
  backdrop: true
}) {
  return Component => class Modable extends Component {
    modal(additionalProps = {}) {
      let modal = modals.get(this.props.modal),
          props = {
            ...modalProps,
            ...additionalProps,
            onHide: this.props.onModalClose.bind(null, this.props.modal),
            show: !!this.props.modal,
          };

      return modal ? modal(props) : undefined;
    }
  };
}



// WEBPACK FOOTER //
// ./components/lib/Modable/index.js